import { ReactElement, useEffect } from "react";
import "./qr.css";
import jsQR from "jsqr";

interface Props {
  scanedCode: any
  setScanedCode: any
}

function QrReader(props: Props): ReactElement {
  const {
    scanedCode,
    setScanedCode
  } = props;


  let video: HTMLVideoElement;
  let canvasElement: HTMLCanvasElement;
  let canvas: any;
  let videoStream: any;

  function drawLine(begin: any, end: any, color: any) {
    canvas!.beginPath();
    canvas!.moveTo(begin.x, begin.y);
    canvas!.lineTo(end.x, end.y);
    canvas!.lineWidth = 4;
    canvas!.strokeStyle = color;
    canvas!.stroke();
  }

  // スマホの縦横検出
  const setDeviceAngle = () => {
    const userAgent = window.navigator.userAgent;

    // 角度を取得
    let angle;
    if (userAgent.match(/Android/)) {
      angle = window.screen.orientation.angle;
    } else if (userAgent.match(/iPhone/)) {
      // 2023年6月現在、iOSは 非推奨の window.orientation で角度を取得する必要あり
      angle = window.orientation;
    } else {
      angle = window.screen.orientation.angle;
    }
  };

  useEffect(() => {
    // 初回の角度検出
    setDeviceAngle();

    // 向き検出イベント
    window.addEventListener("orientationchange", setDeviceAngle);

    // カメラON/OFF
    const mkTurnCamera = (event: MessageEvent): void => {
      if (!event?.data) {
        return
      }
      switch(event.data.source) {
        case 'mkTurnOnCamera': {
          window.localStorage.setItem('camera_control', 'mkTurnOnCamera');
          upCamera();
          break
        }
        case 'mkTurnOffCamera': {
          window.localStorage.setItem('camera_control', 'mkTurnOffCamera');
          downCamera();
          break
        }
      }
    };
    window.addEventListener("message", mkTurnCamera);

    const localStorageValue = localStorage.getItem('camera_control');

    if (!localStorageValue || localStorageValue === 'mkTurnOnCamera') {
      upCamera()
    } else {
      downCamera()
    }

    return () => {
      window.removeEventListener("orientationchange", setDeviceAngle);
      window.removeEventListener("message", mkTurnCamera);
      downCamera()
    }

    // eslint-disable-next-line
  }, []);

  function upCamera() {
    video = document.getElementById("video") as HTMLVideoElement;
    canvasElement = document.getElementById("canvas") as HTMLCanvasElement;
    canvas = canvasElement?.getContext("2d", { willReadFrequently: true });

    const supports = navigator.mediaDevices.getSupportedConstraints();
    if (supports.width && supports.height && supports.facingMode) {
      navigator.mediaDevices
        .getUserMedia({
          video: {
            facingMode: "environment",
            width: 330,
            height: 330,
          },
          audio: false,
        })
        .then(function (stream) {
          videoStream = stream;
          video.srcObject = stream;
          setTimeout(() => {
            video.play()
            requestAnimationFrame(tick);
          }, 100)
        }).catch((err) => {
        });
    } else {
      navigator.mediaDevices
        .getUserMedia({
          video: true,
          audio: false,
        })
        .catch((err) => {
        });
    }
  }

  function downCamera() {
    if (!videoStream) return

    videoStream.getVideoTracks().forEach((track: any) => {
      track.stop();
    })
  }

  let enableRefresh: boolean = true;

  function tick() {
    if (
      video.readyState === video.HAVE_ENOUGH_DATA &&
      scanedCode === "" &&
      enableRefresh
    ) {
      canvasElement.hidden = false;

      if (video.videoHeight < video.videoWidth) {
        canvasElement.width = video.videoWidth;
        canvasElement.height = video.videoHeight;
      } else {
        canvasElement.width = video.videoHeight;
        canvasElement.height = video.videoWidth;
      }
      canvas!.drawImage(video, 0, 0, canvasElement.width, canvasElement.height);

      if (!videoStream.active) return

      const imageData = canvas!.getImageData(
        0,
        0,
        canvasElement.width,
        canvasElement.height
      );
      const code = jsQR(imageData.data, imageData.width, imageData.height, {
        inversionAttempts: "dontInvert",
      });

      // 写されたQRコードを赤枠で囲む
      if (code) {
        drawLine(
          code.location.topLeftCorner,
          code.location.topRightCorner,
          "#FF3B58"
        );
        drawLine(
          code.location.topRightCorner,
          code.location.bottomRightCorner,
          "#FF3B58"
        );
        drawLine(
          code.location.bottomRightCorner,
          code.location.bottomLeftCorner,
          "#FF3B58"
        );
        drawLine(
          code.location.bottomLeftCorner,
          code.location.topLeftCorner,
          "#FF3B58"
        );

        if (code.data !== "") {
          setScanedCode(code.data);
          enableRefresh = false;
          setTimeout(() => {
            enableRefresh = true;
          }, 2000);
        }
      }
    } else {
    }
    requestAnimationFrame(tick);
  }

  return (
    <>
      <video id="video" autoPlay muted playsInline hidden></video>
      <canvas id="canvas" hidden></canvas>
    </>
  );
}

export default QrReader;
